import React from "react";
import { Settings } from "lucide-react";

type Props = {
  className?: string;
  size?: number;
};

export default function IconSettings({ className, size = 16 }: Props) {
  return <Settings className={className} width={size} height={size} />;
}


